import { render, staticRenderFns } from "./AddPreset.vue?vue&type=template&id=d8d23182&scoped=true&"
import script from "./AddPreset.vue?vue&type=script&lang=js&"
export * from "./AddPreset.vue?vue&type=script&lang=js&"
import style0 from "./AddPreset.vue?vue&type=style&index=0&id=d8d23182&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d23182",
  null
  
)

export default component.exports